import type { FaireBrandEntity } from "../../entity_types/brand";

export const driftless_studios: FaireBrandEntity = {
  token: "driftless-studios",
  type: "brand",
  name: "Driftless Studios",
  location: "Westby, WI",
  minimumOrderDollars: 150,
  rating: 5,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "parity-fix",
  },
};
